import { render, staticRenderFns } from "./CIncrustList.vue?vue&type=template&id=22a203ba&scoped=true&"
import script from "./CIncrustList.vue?vue&type=script&lang=js&"
export * from "./CIncrustList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a203ba",
  null
  
)

export default component.exports